<template>
  <invoices-table></invoices-table>
</template>
<script>
import InvoicesTable from "../components/Invoice/InvoicesTable.vue";

export default {
  name: "InvoicesView",
  components: {
    InvoicesTable,
  },
};
</script>
